export function IconFilter() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <path fillRule="evenodd" clipRule="evenodd" d="M1 2a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H2a1 1 0 0 1-1-1zm1 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H2z"/>
        </svg>

    );
}
